<template>
  <div class="page">
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName"
                        @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <el-drawer class="visitor-drawer" :visible.sync="updateDrawerShow" :with-header="false" direction="rtl"
               size="500px">
      <div class="drawer-header">
        <h3>修改信息</h3>
      </div>
      <div class="drawer-content">
        <el-form ref="addForm" class="drawer-form" :rules="rules" :model="selectVisitor" size="mini">
          <el-form-item label="访客姓名" prop="name" label-width="80px">
            <el-input v-model="selectVisitor.name"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="tel" label-width="80px">
            <el-input v-model="selectVisitor.tel"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company" label-width="80px">
            <el-input v-model="selectVisitor.company"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="ic" label-width="80px" v-if="visitorShowSetting.showIC">
            <el-input v-model="selectVisitor.ic"></el-input>
          </el-form-item>
          <el-form-item label="国籍" prop="nationality" label-width="80px" v-if="visitorShowSetting.showNationality">
            <el-input v-model="selectVisitor.nationality"></el-input>
          </el-form-item>
          <el-form-item label="护照号码" prop="tag" label-width="80px" v-if="visitorShowSetting.showPassport">
            <el-input v-model="selectVisitor.tag"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email" label-width="80px" v-if="visitorShowSetting.showEmail">
            <el-input v-model="selectVisitor.email"></el-input>
          </el-form-item>
          <el-form-item label="车牌号码" prop="car" label-width="80px">
            <el-input v-model="selectVisitor.car"></el-input>
          </el-form-item>
          <el-form-item label="地址信息" prop="address" label-width="80px">
            <el-input v-model="selectVisitor.address"></el-input>
          </el-form-item>
          <el-form-item label="访客卡号" prop="cardNo" label-width="80px">
            <el-input v-model="selectVisitor.cardNo"></el-input>
          </el-form-item>
          <el-form-item label="备注信息" prop="comments" label-width="80px">
            <el-input v-model="selectVisitor.comments"></el-input>
          </el-form-item>
          <el-form-item label="访客类型" prop="type" label-width="80px">
            <el-select v-model="selectVisitor.type" placeholder="请选择" @change="onVisitorTypeSelectChange">
              <el-option label="普通访客" value="common"></el-option>
              <el-option label="常访访客" value="usual"></el-option>
              <el-option label="供应商访客" value="provider"></el-option>
              <el-option label="黑名单访客" value="black"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="对接员工" label-width="80px" v-if="selectVisitor.type === 'usual'">
            <el-select v-model="selectVisitor.contactEmployee" value-key="code" filterable remote
                       :remote-method="employeeFilter" clearable placeholder="请选择" :loading="searchLoading">
              <el-option v-for="item in employeeList" :key="item.code"
                         :label="`${item.name} | ${item.tel} | ${item.departmentName}`" :value="item"></el-option>

            </el-select>
          </el-form-item>
          <el-form-item label="有效期限" label-width="80px" required v-if="selectVisitor.type === 'usual'">
            <el-select v-model="selectVisitor.usualExtraType" placeholder="请选择">
              <el-option label="永久有效" value="none"></el-option>
              <el-option label="自定义有效范围" value="have"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" label-width="80px" required v-if="selectVisitor.usualExtraType === 'have'">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            v-model="selectVisitor.usualExtraBegin" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" label-width="80px" required v-if="selectVisitor.usualExtraType === 'have'">
            <el-date-picker value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            v-model="selectVisitor.usualExtraEnd" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-form>

      </div>
      <div class="drawer-bottom">
        <el-button size="mini" type="primary" @click="onUpdateVisitorClick">确 定</el-button>
        <span style="width: 100px"></span>
        <el-button size="mini" @click="updateDrawerShow = false">取 消</el-button>
      </div>
    </el-drawer>

    <div class="main-area">
      <div class="header-area">
        <div>
          <el-input size="small" placeholder="请输入姓名或手机号" v-model="searchInput">
            <el-button @click="onSearchClick" slot="append">搜索</el-button>
          </el-input>
          <el-button v-if="hasCommitPermission" type="danger" plain size="mini" style="margin-left: 30px"
                     @click="cleartextShow('访客查询')">明文查看
          </el-button>
        </div>
      </div>
      <div class="mainContainer">
        <el-table :data="tableData" border>
          <el-table-column prop="name" label="姓名" width="140"></el-table-column>
          <el-table-column prop="type" label="访客类型" width="150">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.type === 'usual'">常访访客</el-tag>
              <el-tag type="danger" v-else-if="scope.row.type === 'black'">黑名单访客</el-tag>
              <el-tag type="warning" v-else-if="scope.row.type === 'provider'">供应商访客</el-tag>
              <el-tag v-else>普通访客</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="tel" label="手机号" width="120">
            <template slot-scope="scope">
              <template v-if="phoneNumShow">{{ scope.row.tel }}</template>
              <template v-else>{{ scope.row.tel | phNoFilter }}</template>
            </template>
          </el-table-column>
          <el-table-column prop="ic" label="身份证" v-if="visitorShowSetting.showIC">
            <template slot-scope="scope">
              <template v-if="phoneNumShow">{{ scope.row.ic }}</template>
              <template v-else>{{ scope.row.ic | icNoFilter }}</template>
            </template>
          </el-table-column>
          <el-table-column prop="nationality" label="国籍" v-if="visitorShowSetting.showNationality"></el-table-column>
          <el-table-column prop="tag" label="护照号" v-if="visitorShowSetting.showPassport"></el-table-column>
          <el-table-column prop="email" label="电子邮箱" v-if="visitorShowSetting.showEmail"></el-table-column>

          <el-table-column prop="cardNo" label="访客卡号"></el-table-column>
          <el-table-column prop="company" label="公司"></el-table-column>


          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="tableUpdate(scope.row)" :disabled="!hasCommitPermission">修改
              </el-button>
              <el-button type="danger" size="mini" @click="tableDel(scope.row)" :disabled="!hasCommitPermission">删除
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <div class="pager">
          <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                         :page-size.sync="curPageSize" :pager-count="5"
                         :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {mixin_clearPhoneNumShow, mixin_page_table, mixin_visitor_setting} from "@/utils/mixin";
import {deleteVisitor, getVisitorList, updateVisitor} from "@/api/visitor-api";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {to_employee_mixin} from "./to_employee_mixin"

export default {
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow, to_employee_mixin, mixin_visitor_setting],
  data() {
    return {
      searchInput: '',
      selectVisitor: {},
      updateDrawerShow: false,
    }
  },

  async mounted() {
    this.refreshTableData()
    await this.setupInviteVisitorSetting()
  },

  methods: {
    refreshTableData() {
      let postData = {
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      if (this.searchInput) {
        if (isNaN(this.searchInput)) {
          postData.name = this.searchInput
        } else {
          postData.tel = this.searchInput
        }
      }
      getVisitorList(postData).then(({data}) => {
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals
        }
      }).catch(error => {
        console.log("getVisitorList err =>", error)
      })

    },


    onSearchClick() {
      this.curPageIndex = 1
      this.refreshTableData()
    },

    tableUpdate(row) {
      if (!this.phoneNumShow) {
        this.cleartextShow('访客查询')
        return
      }
      row.usualExtraType = ""
      row.usualExtraBegin = ""
      row.usualExtraEnd = ""
      if (row.usualTimeLimit) {
        let usualTimeLimit = JSON.parse(row.usualTimeLimit)
        row.usualExtraType = usualTimeLimit.type
        row.usualExtraBegin = usualTimeLimit.beginTime
        row.usualExtraEnd = usualTimeLimit.endTime
      }
      this.selectVisitor = JSON.parse(JSON.stringify(row))

      this.requestBindEmployee(this.selectVisitor.contactEmployeeCode)

      this.updateDrawerShow = true
    },

    tableDel(row) {
      console.log("tableDel =>", row.id)
      deleteVisitor(row.id).then(({data}) => {
        console.log("deleteVisitor result =>", data)
        if (data.code === 200) {
          this.$message.success("删除成功")
          this.tableAllData = this.tableAllData.filter(item => item.id !== row.id)
          this.tableShowData = this.tableShowData.filter(item => item.id !== row.id)
          this.initPaginationTable()
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log("deleteVisitor err =>", err)
        this.showNetErrMsg();
      })
    },

    onUpdateVisitorClick() {
      console.log("onUpdateVisitorClick")
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let contactEmployeeCode = this.selectVisitor.contactEmployee ? this.selectVisitor.contactEmployee.code : ""
          let postData = {
            id: this.selectVisitor.id,
            name: this.selectVisitor.name,
            tel: this.selectVisitor.tel,
            company: this.selectVisitor.company,
            ic: this.selectVisitor.ic,
            tag: this.selectVisitor.tag,
            email: this.selectVisitor.email,
            car: this.selectVisitor.car,
            address: this.selectVisitor.address,
            comments: this.selectVisitor.comments,
            type: this.selectVisitor.type,
            contactEmployeeCode: contactEmployeeCode,
            cardNo: this.selectVisitor.cardNo,
            nationality: this.selectVisitor.nationality,
            usualTimeLimit: "",
          }
          if (this.selectVisitor.type === "usual") {
            if (!this.selectVisitor.usualExtraType) {
              this.$message.error("请选择有效期限")
              return
            }
            if (this.selectVisitor.usualExtraType === "have") {
              if (!this.selectVisitor.usualExtraBegin || !this.selectVisitor.usualExtraEnd) {
                this.$message.error("请选择开始和结束时间")
                return
              }
              let begin = new Date(this.selectVisitor.usualExtraBegin)
              let end = new Date(this.selectVisitor.usualExtraEnd)
              if (begin > end) {
                this.$message.error("结束时间需要大于开始时间")
                return
              }
            }

            let limit = {
              type: this.selectVisitor.usualExtraType,
              beginTime: this.selectVisitor.usualExtraBegin,
              endTime: this.selectVisitor.usualExtraEnd,
            }
            postData.usualTimeLimit = JSON.stringify(limit)
          }
          if (!this.checkoutVisitorValidate(postData)) {
            return
          }
          this.doUpdateVisitor(postData)
          this.updateDrawerShow = false
        }
      });

    },

    doUpdateVisitor(data) {
      updateVisitor(data).then(({data}) => {
        console.log("updateVisitor result =>", data)
        if (data.code === 200) {
          this.$message.success("修改成功")

          this.refreshTableData()

        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(err => {
        console.log("updateVisitor err =>", err)
        this.showNetErrMsg();
      })
    },


    onVisitorTypeSelectChange(val) {
      console.log("onVisitorTypeSelectChange", val)
      this.selectVisitor.type = val
      if (val !== "usual") {
        this.selectVisitor.usualExtraType = ""
        this.selectVisitor.usualExtraBegin = ""
        this.selectVisitor.usualExtraEnd = ""
      }
    },


  },

  computed: {
    hasCommitPermission: function () {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false
        case "COMMON":
          return this.$store.state.myPermissions.includes("VISITOR_MANAGE_MODIFY")
        default:
          return false
      }

    },
  },

}

</script>

<style scoped lang="less">
.page {
  height: 100%;
  width: 100%;

  .main-area {
    height: 100%;
    width: 100%;

    .header-area {
      display: flex;
      align-items: start;
      flex-direction: row;
      justify-content: space-between;
      height: 50px;

      .el-input {
        width: 300px;
      }
    }

  }

  .mainContainer {
    height: calc(100vh - 170px);
    overflow: auto;
    background-color: white;
  }
}

.visitor-drawer {
  .drawer-header {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .drawer-content {
    height: calc(100vh - 120px);
    overflow: auto;

    .drawer-form {
      margin: 20px;
    }
  }

  .drawer-bottom {
    height: 60px;

    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.el-select {
  width: 380px;
}

.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 380px;
}
</style>
